/**
 * Created by alex.y on 7/19/2017.
 */

import {Component, OnInit} from "@angular/core";
import {CurrencyItem} from "../../objects/currencyExchange/currencyItem";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: "currency-dashboard",
    templateUrl: "./currencyDashBoard.component.html",
    moduleId: module.id.toString()
})
export class CurrencyDashBoardComponent implements OnInit {
    public currencyArray: Array<CurrencyItem> = [];

    constructor(private route: ActivatedRoute) {
    }

    public ngOnInit(): void {
        this.currencyArray = this.route.snapshot.data.currencyItems
    }
}


// WEBPACK FOOTER //
// ./app/components/currencyExchange/currencyDashBoard.component.ts